module.exports = __webpack_public_path__ + "images/embed/global_search_box.gif";